export const button = {
  borderRadius: '5px',
  colorScheme: {
    light: {
      primary: {
        color: '{inverse.text.color}',
      },
      // Secondary = color secundario de marca (--p-secondary-*).
      // Filled aquí (mode-aware); outlined/text en el bloque css de abajo.
      secondary: {
        background: '{secondary.500}',
        hoverBackground: '{secondary.600}',
        activeBackground: '{secondary.700}',
        borderColor: '{secondary.500}',
        hoverBorderColor: '{secondary.600}',
        activeBorderColor: '{secondary.700}',
        color: '#ffffff',
        hoverColor: '#ffffff',
        activeColor: '#ffffff',
      },
    },
    dark: {
      primary: {
        color: '{text.color}',
      },
      secondary: {
        background: '{secondary.500}',
        hoverBackground: '{secondary.400}',
        activeBackground: '{secondary.300}',
        borderColor: '{secondary.500}',
        hoverBorderColor: '{secondary.400}',
        activeBorderColor: '{secondary.300}',
        color: '#ffffff',
        hoverColor: '#ffffff',
        activeColor: '#ffffff',
      },
    },
  },
  extend: {
    accent: {
      color: '#f59e0b',
      inverseColor: '#ffffff',
      borderColor: '#f59e0b',
    },
  },
  css: ({ dt }: { dt: (key: string) => string }) => `
      .p-button-accent {
        background: ${dt('button.accent.color')};
        color: ${dt('button.accent.inverse.color')};
        transition-duration: ${dt('my.transition.fast')};
      }

      /* Secondary outlined / text = color secundario de marca (--p-secondary-*) */
      .p-button-outlined.p-button-secondary {
        border-color: ${dt('secondary.500')};
        color: ${dt('secondary.600')};
        background: transparent;
      }
      .p-button-outlined.p-button-secondary:not(:disabled):hover {
        background: ${dt('secondary.50')};
        border-color: ${dt('secondary.600')};
        color: ${dt('secondary.700')};
      }
      .p-button-text.p-button-secondary {
        color: ${dt('secondary.600')};
        background: transparent;
      }
      .p-button-text.p-button-secondary:not(:disabled):hover {
        background: ${dt('secondary.50')};
        color: ${dt('secondary.700')};
      }

      /* Primary outlined/text en modo oscuro: el primary de PrimeNG en dark
         (#12635f) queda ilegible sobre superficies oscuras. Forzamos un teal
         claro con buen contraste. */
      .app-dark .p-button-outlined:not(.p-button-secondary) {
        border-color: #54c6bc;
        color: #54c6bc;
      }
      .app-dark .p-button-outlined:not(.p-button-secondary):not(:disabled):hover {
        background: rgba(84, 198, 188, 0.1);
        border-color: #6fd2c8;
        color: #6fd2c8;
      }
      .app-dark .p-button-text:not(.p-button-secondary):not(:disabled) {
        color: #54c6bc;
      }
    `,
};
